/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  signal,
} from "@angular/core";
import {
  FormGroup,
  ReactiveFormsModule,
  FormsModule,
  FormArray,
} from "@angular/forms";
import { AccordionModule } from "primeng/accordion";
import { MessageService } from "primeng/api";
import { BadgeModule } from "primeng/badge";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DividerModule } from "primeng/divider";
import { TagModule } from "primeng/tag";
import { InputTextModule } from "primeng/inputtext";
import { StepperModule } from "primeng/stepper";
import { TextareaModule } from "primeng/textarea";
import { TooltipModule } from "primeng/tooltip";
import { SelectModule } from "primeng/select";
import { RadioButtonModule } from "primeng/radiobutton";
import {
  catchError,
  debounceTime,
  finalize,
  map,
  Observable,
  of,
  Subject,
  Subscription,
  switchMap,
  tap,
} from "rxjs";
import { ScheduledOrderTotals } from "../../../../../core/models/scheduled-order-totals.interface";
import { ScheduledOrder } from "../../../../../core/models/scheduled-order.interface";
import { ScheduledOrderItem } from "../../../../../core/models/scheduled-order-item.interface";
import { Site } from "../../../../../core/models/site.interface";
import { ScheduledOrderService } from "../../../services/scheduled-order.service";
import { QPilotAccessToken } from "../../../../../core/services/qpilot.service";
import { NextimeService } from "../../../../../core/services/nextime.service";
import {
  NextimeDeliveryDate,
  NextimeShippingLine,
  NextimeShippingLinesData,
} from "../../../../../core/models/nextime-response.interface";
import { NextimeRequestPayload } from "../../../../../core/models/nextime-request.interface";
import { CouponManagerComponent } from "../coupon-manager/coupon-manager.component";
import { CustomerSelectorComponent } from "../customer-selector/customer-selector.component";
import { FrequencyEditorComponent } from "../frequency-editor/frequency-editor.component";
import { ItemManagerComponent } from "../item-manager/item-manager.component";
import { PaymentSelectorComponent } from "../payment-selector/payment-selector.component";
import { SectionBannerComponent } from "../section-banner/section-banner.component";
import { ShippingSelectorComponent } from "../shipping-selector/shipping-selector.component";
import { ShippingRateSelectorComponent } from "../shipping-rate-selector/shipping-rate-selector.component";
import { TotalsDisplayComponent } from "../totals-display/totals-display.component";
import { ValidationChecksInlineViewComponent } from "../../validation-checks-inline-view/validation-checks-inline-view.component";
import { TimezoneSelectorComponent } from "../timezone-selector/timezone-selector.component";
import { TimePickerComponent } from "../time-picker/time-picker.component";
import { TimezoneHelper } from "../../../../../core/helpers/timezone.helper";
import { SubscriptionUpgradeDialogComponent } from "../../../../../shared/dialogs/subscription-upgrade-dialog/subscription-upgrade-dialog.component";
import { ScheduledOrderForm } from "../../../interfaces/scheduled-order-form.interface";
import { ScheduledOrderSummaryComponent } from "../../scheduled-order-summary/scheduled-order-summary.component";

/**
 * Unified form wrapper component for creating and editing scheduled orders
 * Composes all shared components and manages data flow between them
 */
@Component({
  selector: "app-scheduled-order-form",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CardModule,
    ButtonModule,
    DividerModule,
    InputTextModule,
    TextareaModule,
    StepperModule,
    AccordionModule,
    BadgeModule,
    TooltipModule,
    TagModule,
    SelectModule,
    RadioButtonModule,
    CustomerSelectorComponent,
    ItemManagerComponent,
    CouponManagerComponent,
    FrequencyEditorComponent,
    PaymentSelectorComponent,
    ShippingSelectorComponent,
    ShippingRateSelectorComponent,
    TotalsDisplayComponent,
    SectionBannerComponent,
    ValidationChecksInlineViewComponent,
    TimezoneSelectorComponent,
    TimePickerComponent,
    SubscriptionUpgradeDialogComponent,
    ScheduledOrderSummaryComponent,
  ],
  templateUrl: "./scheduled-order-form.component.html",
  styleUrl: "./scheduled-order-form.component.scss",
})
export class ScheduledOrderFormComponent implements OnDestroy {
  // Strongly-typed reactive form (use setter to subscribe to changes)
  private _formGroup!: FormGroup<ScheduledOrderForm>;
  private formSubscriptions: Subscription[] = [];
  private formGroupReady = false;
  private scheduledOrderReady = false;
  private initialLoadComplete = false;

  @Input() set formGroup(value: FormGroup<ScheduledOrderForm>) {
    this._formGroup = value;
    if (value) {
      this.formGroupReady = true;
      this.setupFormSubscriptions();
      // Try to call refreshTotals if both inputs are ready
      this.tryInitialRefreshTotals();
    }
  }

  get formGroup(): FormGroup<ScheduledOrderForm> {
    return this._formGroup;
  }

  @Input() siteId!: number;
  @Input() site?: Site;

  private _mode: "create" | "edit" = "create";
  @Input() set mode(value: "create" | "edit") {
    this._mode = value;
    // Try to refresh totals when mode changes to edit (in case it was set after other inputs)
    if (value === "edit") {
      this.tryInitialRefreshTotals();
    }
  }

  get mode(): "create" | "edit" {
    return this._mode;
  }

  @Input() disabled = false;
  @Input() advancedOptionsAllowed = true;
  @Input() tierName = "";
  @Input() upgradeUrl = "/my-account/subscription/change-plan";
  @Input() isSaving = false;
  @Input() showActions = true; // Control whether to show bottom sticky actions
  @Input() showValidation = false; // Show validation as Step 0 (edit mode only)
  @Input() accessToken?: QPilotAccessToken; // Optional token for embedded mode

  // Readonly edit-mode fields (not in form - passed separately for display)
  @Input() lastProcessingCycle: any = null;
  @Input() lastOccurrenceUtc: Date | null = null;
  @Input() validationResult: any = null;

  // Use setter to track when scheduledOrder is ready
  private _scheduledOrder?: ScheduledOrder;

  @Input() set scheduledOrder(value: ScheduledOrder | undefined) {
    this._scheduledOrder = value;
    if (value) {
      // CRITICAL: Initialize shipping data from loaded order (matches old QMC)
      // This prevents using hardcoded defaults that lose the ShippingLines data
      if (value.FreeShipping) {
        this.freeShipping = value.FreeShipping;
      }

      // CRITICAL FIX: Always set shippingRateOptions from loaded order, even if empty
      // This ensures the local state matches what was loaded from API
      // Previously this only set when length > 0, causing issues with orders that have empty ShippingRateOptions
      this.shippingRateOptions = value.ShippingRateOptions || [];

      // CRITICAL: Calculate FreeShipping from ShippingRateOptions if not already set (matches old QMC line 1003)
      // API doesn't return FreeShipping directly, we must find it from ShippingRateOptions
      if (
        !this.freeShipping &&
        value.ShippingRateOptions &&
        value.ShippingRateOptions.length > 0
      ) {
        const defaultRate = value.ShippingRateOptions.find((s) => s.IsDefault);
        if (defaultRate) {
          this.freeShipping = defaultRate;
        }
      }

      this.scheduledOrderReady = true;
      // Try to call refreshTotals if both inputs are ready
      this.tryInitialRefreshTotals();
    }
  }

  get scheduledOrder(): ScheduledOrder | undefined {
    return this._scheduledOrder;
  }

  // Nextime inputs (matches old QMC lines 232-234)
  @Input() hasNextime = false;
  @Input() nextimeSiteId: string | null = null;
  @Input() nextimeSiteToken: string | null = null;
  @Input() nextimeShouldDisplayDeliveryDate = true;
  @Input() nextimeShouldAlignNextOrderDate = true;

  // Nextime shipping options input setter (matches old QMC lines 337-341)
  private _nextimeShippingOptions: NextimeShippingLinesData | null = null;

  @Input() set nextimeShippingOptions(value: NextimeShippingLinesData | null) {
    this._nextimeShippingOptions = value;
    if (value && value.deliveryDates && value.deliveryDates.length > 0) {
      // Auto-select first delivery date (matches old QMC line 341)
      this.selectedDeliveryDate = value.deliveryDates[0];

      // Update selected shipping line to sync with PreferredShippingRateOption
      // Matches old QMC line 990 - called after shipping options refresh
      this.updateSelectedShippingLine();
    } else {
      this.selectedDeliveryDate = null;
    }
  }

  get nextimeShippingOptions(): NextimeShippingLinesData | null {
    return this._nextimeShippingOptions;
  }

  // NOTE: No @Output() orderChange - form handles synchronization automatically
  @Output() formCancel = new EventEmitter<void>();
  @Output() formSubmit = new EventEmitter<void>();

  // Last Processing Cycle events
  @Output() viewCycleDetails = new EventEmitter<number>();
  @Output() viewProcessingLogs = new EventEmitter<any>();

  // Totals state
  totals?: ScheduledOrderTotals;
  isCalculatingTotals = false;
  totalsError = false;
  private isUpdatingFromCalculation = false; // Prevent recalculation loops

  // Shipping rate options state (matches old QMC lines 1001-1004)
  // Stored outside form as they're managed by API and not user-editable
  // Made public so template can pass to shipping-rate-selector child component
  shippingRateOptions: any[] = [];
  private freeShipping: any = null; // CRITICAL: Don't use hardcoded default - will be set from scheduledOrder or shipping rates API

  // Totals observer pattern - matches old QMC line 114
  // Used to wait for totals completion before saving
  private totalsResult: Subject<boolean> = new Subject<boolean>();

  // Event emitter for totals completion - matches old QMC DashboardScheduledOrdersTotalsComponent line 20
  @Output() totalsCalculationComplete = new EventEmitter<string>();

  // Validation state - for pre-validation refresh after totals
  @Output() validationRefreshComplete = new EventEmitter<void>();

  // Event to open totals popover (triggered from summary component $ icon)
  @Output() openTotalsPopover = new EventEmitter<MouseEvent>();

  // Stepper state
  currentStep = signal<number>(0);

  // Payment step state - tracks if new payment method form is valid
  // Used for step validation when user creates new payment method (paymentMethodId is null)
  isNewPaymentMethodValid = false;

  // ViewChild for payment selector to reload after new payment method creation
  @ViewChild(PaymentSelectorComponent)
  paymentSelector?: PaymentSelectorComponent;

  // Sidebar collapse state
  sidebarCollapsed = signal<boolean>(false);

  // Mobile stepper expansion state (collapsed by default for space saving)
  mobileStepperExpanded = signal<boolean>(false);

  // Accordion state (optional sections collapsed by default)
  showCoupons = signal<boolean>(false);
  showAdvancedOptions = signal<boolean>(false);

  // Advanced options state (matches old QMC lines 232-234)
  nextOccurrenceTime: string | null = null; // HH:mm format
  customerTimezone: number | null = null; // UTC offset

  // Upgrade dialog state (matches old QMC lines 1584-1596)
  showUpgradeDialog = false;

  // Products step accordion - track which panels are open (value="0" = Order Items panel)
  // Panel open by default - uses array of value strings matching panel value attributes
  // In PrimeNG v19, [multiple]="true" requires [(value)] with string[] matching panel values
  productsAccordionActiveValue: string[] = ["0"];

  // Item 16: Coupons step accordion - uses [(value)] binding like products step
  // On mobile: "0" = Order Summary, "1" = Coupons
  // On desktop: only "0" = Coupons (summary panel hidden)
  // Set both "0" and "1" to open content on both desktop and mobile
  couponsAccordionActiveValue: string[] = ["0", "1"];

  // Item 16: Options step accordion - uses [(value)] binding like products step
  // On mobile: "0" = Order Summary, "1" = Options
  // On desktop: only "0" = Options (summary panel hidden)
  // Set both "0" and "1" to open content on both desktop and mobile
  optionsAccordionActiveValue: string[] = ["0", "1"];

  // Nextime UI state (matches old QMC lines 337-341)
  selectedDeliveryDate: NextimeDeliveryDate | null = null;
  selectedShippingLine: NextimeShippingLine | null = null;

  // Track screen width for responsive behavior
  private screenWidth: number;
  isMobile = signal<boolean>(false);

  /**
   * Toggle sidebar collapsed state
   */
  toggleSidebar(): void {
    this.sidebarCollapsed.set(!this.sidebarCollapsed());
  }

  /**
   * Toggle mobile stepper expansion state
   */
  toggleMobileStepper(): void {
    this.mobileStepperExpanded.set(!this.mobileStepperExpanded());
  }

  /**
   * Navigate to previous step (mobile navigation)
   */
  goToPreviousStep(): void {
    const current = this.currentStep();
    if (current > 0) {
      this.currentStep.set(current - 1);
    }
  }

  /**
   * Navigate to next step (mobile navigation)
   * Only allows navigation if current step is complete
   */
  goToNextStep(): void {
    const current = this.currentStep();
    const total = this.getTotalSteps();

    // Check if current step is complete before allowing navigation
    if (current < total - 1 && this.isStepComplete(current)) {
      this.currentStep.set(current + 1);
    }
  }

  /**
   * Check if next button should be enabled
   * Disabled if current step is incomplete or on last step
   */
  canGoToNextStep(): boolean {
    const current = this.currentStep();
    const total = this.getTotalSteps();
    return current < total - 1 && this.isStepComplete(current);
  }

  /**
   * Get current step name for linear progress indicator
   * Item 16: Added "Additional Options" step
   */
  getCurrentStepName(): string {
    const step = this.currentStep();
    const stepNames = this.showValidation
      ? [
          "Summary",
          "Customer",
          "Products",
          "Schedule",
          "Payment",
          "Shipping",
          "Coupons",
          "Additional Options",
          "Validation",
        ]
      : [
          "Customer",
          "Products",
          "Schedule",
          "Payment",
          "Shipping",
          "Coupons",
          "Additional Options",
        ];
    return stepNames[step] || "Unknown";
  }

  /**
   * Get total number of steps
   * Item 16: Updated for new Additional Options step
   */
  getTotalSteps(): number {
    return this.showValidation ? 9 : 7;
  }

  /**
   * Calculate progress percentage for linear indicator
   */
  getProgressPercentage(): number {
    const total = this.getTotalSteps();
    const current = this.currentStep() + 1; // +1 because steps are 0-indexed
    return Math.round((current / total) * 100);
  }

  /**
   * Navigate to Customer step from summary
   */
  onNavigateToCustomer(): void {
    // Customer is step 1 if showValidation is true, otherwise step 0
    this.currentStep.set(this.showValidation ? 1 : 0);
  }

  /**
   * Navigate to Products step from summary
   */
  onNavigateToProducts(): void {
    // Products is step 2 if showValidation is true, otherwise step 1
    this.currentStep.set(this.showValidation ? 2 : 1);
  }

  /**
   * Navigate to Schedule step from summary
   */
  onNavigateToSchedule(): void {
    // Schedule is step 3 if showValidation is true, otherwise step 2
    this.currentStep.set(this.showValidation ? 3 : 2);
  }

  /**
   * Navigate to Coupons step from summary
   */
  onNavigateToCoupons(): void {
    // Coupons is step 6 if showValidation is true, otherwise step 5
    this.currentStep.set(this.showValidation ? 6 : 5);
  }

  /**
   * Navigate to Additional Options step from summary
   * Item 16: New step for custom name and notes
   */
  onNavigateToAdditionalOptions(): void {
    // Additional Options is step 7 if showValidation is true, otherwise step 6
    this.currentStep.set(this.showValidation ? 7 : 6);
  }

  /**
   * Navigate to Validation step from summary
   * Item 16: Updated step index (now step 8)
   */
  onNavigateToValidation(): void {
    // Validation is always step 8 (only shown in edit mode when showValidation is true)
    if (this.showValidation) {
      this.currentStep.set(8);
    }
  }

  /**
   * Handle opening totals popover from summary component $ icon
   */
  onOpenTotalsPopover(event: MouseEvent): void {
    this.openTotalsPopover.emit(event);
  }

  /**
   * Listen for window resize events and auto-collapse/expand sidebar
   * Matches sidebar widget pattern for consistent responsive behavior
   */
  @HostListener("window:resize")
  onResize(): void {
    this.screenWidth = window.innerWidth;
    // Auto-collapse on tablet and mobile (1023px and below)
    // Auto-expand on desktop (above 1023px)
    if (this.screenWidth <= 1023) {
      this.sidebarCollapsed.set(true);
    } else {
      this.sidebarCollapsed.set(false);
    }

    // Track mobile state for order summary placement
    this.isMobile.set(this.screenWidth <= 767);
  }

  constructor(
    private scheduledOrderService: ScheduledOrderService,
    private messageService: MessageService,
    private nextimeService: NextimeService,
  ) {
    // Initialize screen width and auto-collapse sidebar on tablet/mobile (matching sidebar widget pattern)
    this.screenWidth = typeof window !== "undefined" ? window.innerWidth : 1024;
    this.sidebarCollapsed.set(this.screenWidth <= 1023);
    this.isMobile.set(this.screenWidth <= 767);
  }

  /**
   * Clean up subscriptions on component destroy
   */
  ngOnDestroy(): void {
    this.formSubscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Try to call refreshTotals on initial load once both formGroup and scheduledOrder are ready
   * This ensures we have all the data needed before calculating totals (matches old QMC line 216)
   */
  private tryInitialRefreshTotals(): void {
    // Only call once on initial load in edit mode
    if (
      this.initialLoadComplete ||
      this.mode !== "edit" ||
      !this.formGroupReady ||
      !this.scheduledOrderReady
    ) {
      return;
    }

    this.initialLoadComplete = true;

    // Use setTimeout to ensure Angular has finished setting all inputs
    setTimeout(() => {
      this.refreshTotals();
    }, 100);
  }

  /**
   * Setup form subscriptions to auto-calculate totals when items or relevant fields change
   * Matches old QMC behavior where totals are recalculated on item add/remove/edit
   */
  private setupFormSubscriptions(): void {
    // Clear existing subscriptions if any
    this.formSubscriptions.forEach((sub) => sub.unsubscribe());
    this.formSubscriptions = [];

    // Subscribe to scheduled order items changes (add/remove/edit)
    // Debounce to avoid excessive API calls when user is typing
    const itemsSubscription =
      this.formGroup.controls.scheduledOrderItems.valueChanges
        .pipe(
          debounceTime(500), // Wait 500ms after last change before recalculating
        )
        .subscribe(() => {
          // Only calculate if we're not currently updating from a calculation
          // This prevents infinite loops
          if (!this.isUpdatingFromCalculation) {
            // CRITICAL: Must call refreshTotals() not calculateTotals()
            // Item changes may affect coupon validity and shipping rates (matches old QMC line 194)
            this.refreshTotals();
          }
        });

    this.formSubscriptions.push(itemsSubscription);

    // Also subscribe to coupon changes (add/remove coupons should recalculate totals)
    const couponsSubscription =
      this.formGroup.controls.couponsHistory.valueChanges
        .pipe(
          debounceTime(300), // Shorter debounce for coupons
        )
        .subscribe(() => {
          if (!this.isUpdatingFromCalculation) {
            // CRITICAL: Must call refreshTotals() not calculateTotals()
            // refreshTotals() validates coupons BEFORE calculating totals (matches old QMC line 396)
            // calculateTotals() skips validation which causes coupons to be rejected by backend
            this.refreshTotals();
          }
        });

    this.formSubscriptions.push(couponsSubscription);

    // Subscribe to shipping address changes (city, state, postcode affect tax calculation and shipping rates)
    const shippingSubscription =
      this.formGroup.controls.shippingPostcode.valueChanges
        .pipe(debounceTime(500))
        .subscribe(() => {
          if (!this.isUpdatingFromCalculation) {
            // CRITICAL: Must call refreshTotals() because address changes affect shipping rates (matches old QMC line 378)
            this.refreshTotals();
          }
        });

    this.formSubscriptions.push(shippingSubscription);

    // Subscribe to preferred shipping rate option changes
    const shippingRateSubscription =
      this.formGroup.controls.preferredShippingRateOption.valueChanges
        .pipe(debounceTime(300))
        .subscribe(() => {
          if (!this.isUpdatingFromCalculation) {
            this.calculateTotals();
          }
        });

    this.formSubscriptions.push(shippingRateSubscription);
  }

  /**
   * Handle customer selection from CustomerSelectorComponent
   */
  onCustomerChange(customer: any): void {
    this.formGroup.controls.customerId.setValue(customer?.Id || null);
    this.formGroup.controls.customer.setValue(customer);

    // Auto-populate shipping address from customer (like old QMC)
    if (customer) {
      this.formGroup.patchValue({
        shippingFirstName: customer.ShippingFirstName || "",
        shippingLastName: customer.ShippingLastName || "",
        shippingStreet1: customer.ShippingStreet1 || "",
        shippingStreet2: customer.ShippingStreet2 || "",
        shippingCity: customer.ShippingCity || "",
        shippingPostcode: customer.ShippingPostcode || "",
        shippingState: customer.ShippingState || "",
        shippingCountry: customer.ShippingCountry || "",
      });
    }

    // Form automatically syncs - no need to emit
    // Auto-refresh totals when customer changes (like old QMC line 153)
    // CRITICAL: Must call refreshTotals() to validate customer-specific coupons and recalculate shipping
    this.refreshTotals();
  }

  /**
   * Handle items change from ItemManagerComponent
   */
  onItemsChange(items: any[]): void {
    // Items FormArray is managed by ItemManagerComponent
    // This handler is for legacy compatibility if needed
    // Form automatically syncs - no need to emit
    // Auto-refresh totals when items change (like old QMC lines 194, 219, 255, 260, 266, 271, 276, 282)
    // CRITICAL: Must call refreshTotals() to revalidate coupons and recalculate shipping based on items
    this.refreshTotals();
  }

  /**
   * Handle shipping address changes
   * Refreshes totals after address is updated (matches old QMC line 709)
   */
  onAddressChanged(): void {
    this.refreshTotals();
  }

  /**
   * Build ScheduledOrder from form values for API calls
   * Used by calculateTotals and other API operations
   * IMPORTANT: Use getRawValue() to include disabled controls (customer is disabled in edit mode)
   */
  private buildOrderFromForm(): ScheduledOrder {
    // Use getRawValue() to include disabled controls (customer control is disabled in edit mode)
    const formValues = this.formGroup.getRawValue();

    // Map form items (lowercase) to API ScheduledOrderItems (Pascal case)
    // CRITICAL: Field order must match old QMC exactly (API may be order-sensitive)
    // IMPORTANT: ONLY include enabled items (filter out disabled items)
    // Use isItemEnabled() to match the same logic as item-manager's getGrandTotal()
    const scheduledOrderItems =
      formValues.scheduledOrderItems
        ?.filter((item) => this.isItemEnabled(item)) // Use consistent logic for determining enabled items
        .map((item) => {
          // Base fields (always included)
          const baseItem: any = {
            ScheduledOrderId:
              item.scheduledOrderId || this.scheduledOrder?.Id || 0,
            Quantity: item.quantity || 1,
            Product: item.product,
            ProductId: item.productId || 0,
            Price: item.price || 0,
            SalePrice: item.salePrice,
          };

          // Additional fields for existing items (edit mode only)
          // These fields match old QMC payload structure (lines 176-231 in old payload JSON)
          if (this.mode === "edit" && item.id) {
            baseItem.Id = item.id;
            baseItem.OriginalSalePrice =
              item.originalSalePrice ?? item.salePrice;
            baseItem.Cycles = item.cycles ?? 0;
            baseItem.MinCycles = item.minCycles ?? null;
            baseItem.MaxCycles = item.maxCycles ?? null;
            baseItem.CreatedUtc = item.createdUtc || undefined;
            baseItem.UpdatedUtc = item.updatedUtc || undefined;
            baseItem.Metadata = item.metadata || null;
          }

          return baseItem;
        }) || [];

    // Calculate subtotal - matches old QMC line 68
    // Note: This calculation doesn't multiply by quantity, matching old QMC exactly
    // The API appears to need this field even though it recalculates internally
    let subTotal = 0;
    scheduledOrderItems.forEach((item) => {
      subTotal += item.SalePrice || item.Price || 0;
    });

    return {
      Id: this.mode === "edit" ? this.scheduledOrder?.Id || 0 : 0,
      CustomerId: formValues.customerId!,
      Customer: formValues.customer!,
      // CRITICAL: Include LastProcessingCycleId and LastProcessingCycle from existing order (edit mode)
      // Old QMC payload includes these fields (lines 3-4)
      LastProcessingCycleId:
        this.mode === "edit"
          ? this.scheduledOrder?.LastProcessingCycleId
          : undefined,
      LastProcessingCycle:
        this.mode === "edit"
          ? this.scheduledOrder?.LastProcessingCycle
          : undefined,
      FrequencyType: formValues.frequencyType,
      Frequency: formValues.frequency,
      // CRITICAL: Include FrequencyDisplayName (missing in NEW QMC, required by API)
      FrequencyDisplayName:
        this.mode === "edit"
          ? this.scheduledOrder?.FrequencyDisplayName
          : undefined,
      Cycles: formValues.cycles,
      // CRITICAL: Include LastOccurrenceUtc from existing order (edit mode)
      // Old QMC payload includes this field (line 376)
      LastOccurrenceUtc:
        this.mode === "edit"
          ? this.scheduledOrder?.LastOccurrenceUtc
          : undefined,
      NextOccurrenceUtc: formValues.nextOccurrenceUtc as any,
      Status: formValues.status,
      // CRITICAL: Include CreatedUtc and UpdatedUtc from existing order (edit mode)
      // Old QMC payload includes these fields (lines 380-381)
      CreatedUtc:
        this.mode === "edit" ? this.scheduledOrder?.CreatedUtc : undefined,
      UpdatedUtc:
        this.mode === "edit" ? this.scheduledOrder?.UpdatedUtc : undefined,
      ScheduledOrderItems: scheduledOrderItems as any,
      Subtotal: subTotal,
      // CRITICAL: Include totals fields for shipping rate calculation
      // API requires ShippingTotal, TaxTotal, and Total to calculate shipping rates
      // Matches old QMC payload structure (lines 413-416)
      // FIX: On initial load in edit mode, use values from scheduledOrder if totals is undefined
      ShippingTotal:
        this.totals?.ShippingTotals?.Total ??
        this.scheduledOrder?.ShippingTotal ??
        0,
      TaxTotal:
        this.totals?.TaxTotals?.Total ?? this.scheduledOrder?.TaxTotal ?? 0,
      Total: this.totals?.Total ?? this.scheduledOrder?.Total ?? 0,
      Coupons: formValues.coupons || "",
      CouponsHistory: formValues.couponsHistory || [],
      // CRITICAL: Include ShippingRateName from existing order (edit mode)
      // Old QMC payload includes this field (line 417)
      ShippingRateName:
        this.mode === "edit" ? this.scheduledOrder?.ShippingRateName : null,
      ShippingFirstName: formValues.shippingFirstName,
      ShippingLastName: formValues.shippingLastName,
      ShippingStreet1: formValues.shippingStreet1,
      ShippingStreet2: formValues.shippingStreet2,
      ShippingCity: formValues.shippingCity,
      ShippingState: formValues.shippingState,
      ShippingPostcode: formValues.shippingPostcode,
      ShippingCountry: formValues.shippingCountry,
      // CRITICAL: Include SiteShippingAddressId from existing order (edit mode)
      // Old QMC payload includes this field (line 426)
      SiteShippingAddressId:
        this.mode === "edit"
          ? this.scheduledOrder?.SiteShippingAddressId
          : null,
      PreferredShippingRateOption:
        formValues.preferredShippingRateOption || null,
      // CRITICAL: Match EnableAutoShippingRate value from loaded order (OLD QMC: true)
      EnableAutoShippingRate:
        this.mode === "edit"
          ? (this.scheduledOrder?.EnableAutoShippingRate ??
            formValues.enableAutoShippingRate)
          : formValues.enableAutoShippingRate,
      PaymentMethodId: formValues.paymentMethodId || undefined,
      PaymentMethod: formValues.paymentMethod || undefined,
      // CRITICAL: Include missing fields that OLD QMC sends (discovered via payload comparison)
      AuthorizeOnly:
        this.mode === "edit"
          ? (this.scheduledOrder?.AuthorizeOnly ?? false)
          : false,
      Name: formValues.name,
      Note: formValues.note,
      PhoneNumber:
        this.mode === "edit" ? this.scheduledOrder?.PhoneNumber : undefined,
      Company: this.mode === "edit" ? this.scheduledOrder?.Company : undefined,
      NextOccurrenceOffset: formValues.nextOccurrenceOffset,
      CurrencyIso: formValues.currencyIso,
      UtcOffset: formValues.utcOffset,
      DisplaySalePrice: formValues.displaySalePrice,
      // CRITICAL: Include EstimatedDeliveryDate, LifetimeValue, ScheduledOrderFailureReason from existing order (edit mode)
      // Old QMC payload includes these fields (lines 559, 624-625)
      EstimatedDeliveryDate:
        this.mode === "edit"
          ? this.scheduledOrder?.EstimatedDeliveryDate
          : undefined,
      LifetimeValue:
        this.mode === "edit" ? this.scheduledOrder?.LifetimeValue : undefined,
      ScheduledOrderFailureReason:
        this.mode === "edit"
          ? this.scheduledOrder?.ScheduledOrderFailureReason
          : undefined,
      // API-required fields with defaults
      FallbackToQpilotShippingWhenNextimeFails: false,
      // CRITICAL: Use stored shipping options instead of hardcoded values (matches old QMC lines 1001-1004)
      // FIX: On initial load in edit mode, use values from scheduledOrder if shippingRateOptions is empty
      FreeShipping: this.freeShipping ?? this.scheduledOrder?.FreeShipping,
      ProcessingErrorCode: 0,
      ShippingRateOptions:
        this.shippingRateOptions?.length > 0
          ? this.shippingRateOptions
          : this.scheduledOrder?.ShippingRateOptions || [],
      Metadata: null,
      // CRITICAL: Include ValidationResult from existing order (edit mode)
      // Old QMC payload includes this field (line 733)
      ValidationResult:
        this.mode === "edit"
          ? this.scheduledOrder?.ValidationResult
          : undefined,
      TotalNumberOfProcessingCycles:
        this.mode === "edit"
          ? this.scheduledOrder?.TotalNumberOfProcessingCycles
          : undefined,
      PreValidateSynchronously: false,
      // CRITICAL: Match Locked value from loaded order (OLD QMC: true, NEW QMC was: false)
      Locked:
        this.mode === "edit" ? (this.scheduledOrder?.Locked ?? false) : false,
      LastEditableDate: new Date(),
      IsInDunning: false,
      // CRITICAL: Include missing fields that OLD QMC sends (discovered via payload comparison)
      ClientContractId:
        this.mode === "edit"
          ? this.scheduledOrder?.ClientContractId
          : undefined,
      ImportTransactionId:
        this.mode === "edit"
          ? this.scheduledOrder?.ImportTransactionId
          : undefined,
      Origin: this.mode === "edit" ? this.scheduledOrder?.Origin : undefined,
      OriginalExternalId:
        this.mode === "edit"
          ? this.scheduledOrder?.OriginalExternalId
          : undefined,
      PreProcessingValidationResultCode:
        this.mode === "edit"
          ? this.scheduledOrder?.PreProcessingValidationResultCode
          : undefined,
      ShippingRateCalculationErrors:
        this.mode === "edit"
          ? this.scheduledOrder?.ShippingRateCalculationErrors
          : undefined,
    } as unknown as ScheduledOrder;
  }

  /**
   * Calculate order totals using the ScheduledOrderService
   */
  calculateTotals(): void {
    const formValues = this.formGroup.value;

    // Skip if no items or missing required data
    if (
      !formValues.scheduledOrderItems ||
      formValues.scheduledOrderItems.length === 0
    ) {
      this.totals = undefined;
      return;
    }

    if (!formValues.customerId || !formValues.shippingCountry) {
      // Not enough data to calculate totals yet
      return;
    }

    this.isCalculatingTotals = true;
    this.isUpdatingFromCalculation = true;
    this.totalsError = false;

    // Build order from form for API call
    const order = this.buildOrderFromForm();

    // Calculate subtotal client-side before calling API (matches old QMC behavior)
    let subtotal = 0;
    order.ScheduledOrderItems?.forEach((item) => {
      const effectivePrice = item.SalePrice || item.Price || 0;
      const quantity = item.Quantity || 1;
      subtotal += effectivePrice * quantity;
    });
    order.Subtotal = subtotal;

    // Clean Customer object to remove displayLabel (added by new QMC UI)
    const cleanCustomer = order.Customer
      ? (() => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const { displayLabel, ...customer } = order.Customer as any;
          return customer;
        })()
      : order.Customer;

    const isEditMode = this.mode === "edit";

    const cleanedOrder = {
      ...order, // Spread the ENTIRE order (matches old QMC behavior)
      Subtotal: subtotal, // Update calculated subtotal
      ScheduledOrderCoupons: order.CouponsHistory || [], // Required by API
      // CRITICAL: Strip out ALL extra fields from items to make them look like newly added items
      // The API only calculates totals for items WITHOUT the Id field
      // Items with Id are treated as existing items that shouldn't be recalculated
      ScheduledOrderItems: (order.ScheduledOrderItems || []).map((item) => {
        // CRITICAL: ProductId should be the internal Product.Id (number), NOT ExternalId
        // Old QMC sends ProductId: 73028 (Product.Id), not "78" (ExternalId)
        // See "payload from edit old qmc initial load.json" - ProductId is a number
        const productId = item.Product?.Id || item.ProductId;

        // CRITICAL: Only send minimal fields that work for calculateTotals
        // Matches the structure of newly added items that work correctly
        // DO NOT include: Id, CreatedUtc, UpdatedUtc, Cycles, MinCycles, MaxCycles, OriginalSalePrice, Metadata
        const cleanItem: any = {
          Quantity: item.Quantity,
          Product: item.Product,
          ProductId: productId, // Use internal Product.Id (number)
          Price: item.Price,
          SalePrice: item.SalePrice,
        };

        // Add ScheduledOrderId only in edit mode (the order's ID, not the item's ID)
        if (isEditMode && order.Id) {
          cleanItem.ScheduledOrderId = order.Id;
        }

        return cleanItem;
      }),
      // Clean Customer object
      Customer: cleanCustomer,
    };

    // CRITICAL: For CREATE mode, use WHITELIST to match old QMC calculateTotals payload exactly
    // Old QMC calculateTotals payload (see "payload from calculate totals from old qmc.json")
    if (!isEditMode) {
      const createCalcPayload: any = {
        FrequencyType: cleanedOrder.FrequencyType,
        Frequency: cleanedOrder.Frequency,
        ScheduledOrderItems: cleanedOrder.ScheduledOrderItems, // Already cleaned above
        CouponsHistory: cleanedOrder.CouponsHistory || [],
        PaymentMethodId: cleanedOrder.PaymentMethodId || null,
        PaymentMethod: cleanedOrder.PaymentMethod || null,
        CurrencyIso: cleanedOrder.CurrencyIso,
        Status: cleanedOrder.Status,
        UtcOffset: cleanedOrder.UtcOffset,
        CustomerId: cleanedOrder.CustomerId,
        Customer: cleanCustomer,
        ShippingFirstName: cleanedOrder.ShippingFirstName,
        ShippingLastName: cleanedOrder.ShippingLastName,
        ShippingStreet1: cleanedOrder.ShippingStreet1,
        ShippingStreet2: cleanedOrder.ShippingStreet2,
        ShippingCity: cleanedOrder.ShippingCity,
        ShippingPostcode: cleanedOrder.ShippingPostcode,
        ShippingState: cleanedOrder.ShippingState,
        ShippingCountry: cleanedOrder.ShippingCountry,
        // CRITICAL: Match old QMC field order EXACTLY (lines 182-187)
        // Old QMC sends ONLY these 6 fields after ShippingCountry:
        Coupons: cleanedOrder.Coupons || "", // Line 182
        NextOccurrenceOffset: cleanedOrder.NextOccurrenceOffset ?? 0, // Line 183
        Cycles: cleanedOrder.Cycles ?? 0, // Line 184
        Name: cleanedOrder.Name || "", // Line 185
        Note: cleanedOrder.Note || "", // Line 186
        NextOccurrenceUtc: cleanedOrder.NextOccurrenceUtc, // Line 187
      };

      this.scheduledOrderService
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .calculateTotals(this.siteId, createCalcPayload, this.accessToken)
        .pipe(
          tap((calculatedTotals) => {
            this.totals = calculatedTotals;
            // Update form with calculated values (form handles sync automatically)
            this.formGroup.patchValue(
              {
                // Note: We don't have these in the form interface yet, but totals are display-only
              },
              { emitEvent: false },
            );

            // CRITICAL: Sync scheduledOrder.ScheduledOrderItems with form data (set Disabled flags)
            // This ensures the summary component can filter disabled items correctly
            this.syncScheduledOrderItemsWithForm();
          }),
          catchError((error) => {
            console.error("calculateTotals error:", error);
            this.totalsError = true;
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Failed to calculate order totals",
              life: 5000,
            });
            return of(null);
          }),
          finalize(() => {
            this.isCalculatingTotals = false;
            this.isUpdatingFromCalculation = false;
            // Signal totals completion for save observer (CRITICAL for edit save to work)
            this.totalsResult.next(true);
          }),
        )
        .subscribe();
      return;
    }

    // EDIT mode: send full cleanedOrder with proper field cleanup
    // CRITICAL: Clean ShippingRateOptions to match old QMC structure (simple array without nested ShippingLines)
    // CRITICAL: Old QMC sends ShippingRateOptions with FULL structure including ShippingLines
    // See "payload from edit old qmc initial load.json" - ShippingRateOptions[0] has ShippingLines array
    const editCalcPayload: any = {
      ...cleanedOrder,
      // CRITICAL: Keep ShippingRateOptions with ShippingLines intact (don't strip it out!)
      // The API needs ShippingLines to calculate shipping costs correctly
      ShippingRateOptions: cleanedOrder.ShippingRateOptions || [],
      // Ensure ScheduledOrderCoupons is set (matches old QMC qpilot.service.ts:1731)
      ScheduledOrderCoupons: cleanedOrder.CouponsHistory || [],
    };

    this.scheduledOrderService
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .calculateTotals(this.siteId, editCalcPayload, this.accessToken)
      .pipe(
        tap((calculatedTotals) => {
          this.totals = calculatedTotals;
          // Totals are displayed from this.totals object

          // CRITICAL: Sync scheduledOrder.ScheduledOrderItems with form data (set Disabled flags)
          // This ensures the summary component can filter disabled items correctly
          this.syncScheduledOrderItemsWithForm();
        }),
        catchError(() => {
          this.totalsError = true;
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Failed to calculate order totals",
            life: 5000,
          });
          return of(null);
        }),
        finalize(() => {
          this.isCalculatingTotals = false;
          this.isUpdatingFromCalculation = false;
          // Signal totals completion for save observer (CRITICAL for edit save to work)
          this.totalsResult.next(true);
        }),
      )
      .subscribe();
  }

  /**
   * CRITICAL: Sync scheduledOrder.ScheduledOrderItems with form data
   * This method sets the Disabled flag on scheduledOrder items based on product state
   * Called after calculateTotals to ensure summary component can filter disabled items correctly
   *
   * Replicates the disabled item detection logic from ItemManagerComponent:
   * - productIsActive: product.StockLevel is InStock/Undefined, product.Availability includes ProcessScheduledOrder, product.Active, product.Valid
   * - disabledForBackorders: BackordersAllowed is false and Stock < Quantity
   */
  private syncScheduledOrderItemsWithForm(): void {
    if (!this._scheduledOrder || !this._scheduledOrder.ScheduledOrderItems) {
      return;
    }

    // Update Disabled flag on each scheduledOrder item using the same logic as ItemManagerComponent
    this._scheduledOrder.ScheduledOrderItems.forEach((item) => {
      const product = item.Product;

      // If no product, mark as disabled
      if (!product) {
        item.Disabled = true;
        return;
      }

      // Check if product is disabled using the same logic as ItemManagerComponent.getDisabledItems()
      const isProductActive = this.isProductActive(product);
      const isDisabledForBackorders = this.isDisabledForBackorders(item);

      item.Disabled = !isProductActive || isDisabledForBackorders;
    });
  }

  /**
   * Check if product is active (can be processed)
   * Matches ItemManagerComponent.productIsActive logic
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isProductActive(product: any): boolean {
    return (
      this.isProductInStock(product) &&
      this.isProductProcessing(product) &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Active &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Valid
    );
  }

  /**
   * Check if product is in stock
   * Matches ItemManagerComponent.productIsInStock logic
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isProductInStock(product: any): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.StockLevel === "Undefined" || product.StockLevel === "InStock"
    );
  }

  /**
   * Check if product is enabled for processing scheduled orders
   * Matches ItemManagerComponent.productIsProcessing logic
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isProductProcessing(product: any): boolean {
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Availability &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      product.Availability.indexOf("ProcessScheduledOrder") > -1
    );
  }

  /**
   * Check if item is disabled due to backorder restrictions
   * Matches ItemManagerComponent.disabledForBackorders logic
   */
  private isDisabledForBackorders(item: ScheduledOrderItem): boolean {
    const product = item.Product;
    if (!product) return false;

    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      (product as any).BackordersAllowed != null &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      !(product as any).BackordersAllowed &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      (product as any).Stock != null &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      (product as any).Stock < (item.Quantity ?? 0)
    );
  }

  /**
   * Get the reason why an item is disabled (for debugging)
   * Matches ItemManagerComponent.getDisabledReason logic
   */
  private getDisabledReason(item: ScheduledOrderItem): string {
    const product = item.Product;
    if (!product) return "Product information unavailable";

    if (this.isDisabledForBackorders(item)) {
      return "Backorders not allowed and insufficient stock";
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    if (!(product as any).Active) {
      return "Product is inactive";
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    if (!(product as any).Valid) {
      return "Product is invalid";
    }
    if (!this.isProductInStock(product)) {
      return "Product is out of stock";
    }
    if (!this.isProductProcessing(product)) {
      return "Product is not enabled for scheduled orders";
    }

    return "Unknown reason";
  }

  /**
   * Manually trigger totals recalculation with full 4-step flow
   * Matches old QMC lines 461-492: coupon validation → shipping refresh → totals → validation refresh
   * Refactored to pure Observable pattern (matches CLAUDE.md guidelines)
   */
  refreshTotals(): void {
    const formValues = this.formGroup.value;

    // Skip if no items or missing required data
    if (
      !formValues.scheduledOrderItems ||
      formValues.scheduledOrderItems.length === 0
    ) {
      this.totals = undefined;
      return;
    }

    if (!formValues.customerId || !formValues.shippingCountry) {
      // Not enough data to calculate totals yet
      return;
    }

    // Build order from form for API call
    const order = this.buildOrderFromForm();

    // Create observable chain based on whether we have coupons to validate
    const couponValidation$: Observable<void> =
      formValues.coupons && formValues.coupons.trim() !== ""
        ? // Step 1: Validate coupons BEFORE totals (matches old QMC lines 464-476)
          this.scheduledOrderService
            .validateCoupons(this.siteId, order, this.accessToken)
            .pipe(
              tap((validatedCoupons) => {
                // Update CouponsHistory in form with validation results
                const couponsHistory = formValues.couponsHistory || [];
                const updatedCouponsHistory = couponsHistory.map((it) => {
                  const validationResult = validatedCoupons.find(
                    (x) => x.CouponId === it.CouponId,
                  );
                  if (validationResult) {
                    it.Valid = validationResult.Valid;
                    it.Coupon.Valid = validationResult.Coupon.Valid;
                    it.CouponInvalidationCode =
                      validationResult.CouponInvalidationCode;
                  }
                  return it;
                });
                this.formGroup.controls.couponsHistory.setValue(
                  updatedCouponsHistory,
                  { emitEvent: false },
                );
              }),
              map(() => void 0), // Convert to Observable<void>
            )
        : // No coupons to validate, proceed directly to next step
          of(void 0);

    // Chain the full flow: coupon validation → shipping refresh → totals calculation
    couponValidation$
      .pipe(
        // Step 2: Refresh shipping rates (matches old QMC lines 478-491, method at 976-1006)
        switchMap(() => this.refreshShippingRates()),
        // Step 3: Calculate totals (matches old QMC line 479)
        tap(() => {
          // Note: calculateTotals is async and will emit totalsCalculationComplete when done
          this.calculateTotals();
        }),
        // Step 4: Refresh pre-validation AFTER totals complete (matches old QMC lines 482-490)
        // This is handled in the calculateTotals complete callback (line 381)
        catchError((error) => {
          console.error("Error in refreshTotals flow:", error);
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Failed to refresh totals",
            life: 3000,
          });
          return of(void 0);
        }),
      )
      .subscribe();
  }

  /**
   * Refresh shipping rate options
   * Matches old QMC lines 976-1006
   * Refactored to pure Observable pattern (matches CLAUDE.md guidelines)
   * @returns Observable that completes when shipping rates are refreshed
   */
  private refreshShippingRates(): Observable<void> {
    const order = this.buildOrderFromForm();

    return this.scheduledOrderService
      .getShippingRateOptions(this.siteId, order, this.accessToken)
      .pipe(
        tap((shippingOptions) => {
          // CRITICAL: Store shipping options in component state (matches old QMC line 1001)
          // Only update if API returned results, otherwise keep existing options from loaded order
          if (shippingOptions && shippingOptions.length > 0) {
            this.shippingRateOptions = shippingOptions;
          } else if (
            this.shippingRateOptions.length === 0 &&
            this.scheduledOrder?.ShippingRateOptions?.length
          ) {
            // Fallback to order's stored options if API returned empty
            this.shippingRateOptions = this.scheduledOrder.ShippingRateOptions;
          }

          // Set FreeShipping from ShippingRateOptions (matches old QMC line 1003)
          const freeShipping = this.shippingRateOptions.find(
            (s) => s.IsDefault,
          );
          if (freeShipping) {
            this.freeShipping = freeShipping;
          }

          // Set default shipping rate if EnableAutoShippingRate is true (matches old QMC line 1005)
          const enableAuto = this.formGroup.value.enableAutoShippingRate;

          if (enableAuto && freeShipping) {
            // Set the preferred shipping rate in form
            this.formGroup.controls.preferredShippingRateOption.setValue(
              freeShipping.OptionValue,
              { emitEvent: false },
            );
          }
        }),
        map(() => void 0), // Convert to Observable<void>
        catchError((error) => {
          console.error("Error refreshing shipping rates:", error);
          // Return void to continue the flow even on error
          return of(void 0);
        }),
      );
  }

  /**
   * Build Nextime shipping option request payload
   * Matches old QMC lines 269-295
   */
  getNextimeShippingOptionRequest(): NextimeRequestPayload {
    const order = this.buildOrderFromForm();

    return {
      orderId: order.Id?.toString() || "0",
      items: (order.ScheduledOrderItems || []).map((item) => ({
        id: item.Id || 0,
        productId: item.ProductId?.toString() || "0",
        qty: item.Quantity || 0,
        regularPrice: item.Price || 0,
        salePrice: item.SalePrice || 0,
      })),
      shippingAddress: {
        country: order.ShippingCountry || "",
        city: order.ShippingCity || "",
        postalCode: order.ShippingPostcode || "",
        state: order.ShippingState || "",
        street: order.ShippingStreet1 || "",
      },
      shippingOptionFilters: {
        nextOrderDate: order.NextOccurrenceUtc || undefined,
        includeProducts: false,
      },
    };
  }

  /**
   * Update Nextime shipping rate when delivery date or shipping line changes
   * Matches old QMC lines 360-370
   */
  updateNextimeShippingRate(): void {
    if (this.selectedDeliveryDate && this.selectedShippingLine) {
      this.formGroup.controls.preferredShippingRateOption.setValue(
        this.selectedShippingLine.shippingMethod,
        { emitEvent: false },
      );

      // if (this.nextimeShouldDisplayDeliveryDate) {
      //   // EstimatedDeliveryDate not in form yet - would need to add if required
      // }

      // Refresh totals after Nextime selection changes (matches old QMC line 368)
      this.calculateTotals();
    }
  }

  /**
   * Update selected shipping line after shipping rates refresh
   * Syncs UI state with form's PreferredShippingRateOption
   * Matches old QMC lines 1017-1027
   * Called after refreshShippingRates() completes to ensure UI shows correct selection
   */
  private updateSelectedShippingLine(): void {
    // Only update if we have Nextime shipping options and a selected delivery date
    if (!this.selectedDeliveryDate) {
      return;
    }

    const preferredOption = this.formGroup.value.preferredShippingRateOption;

    // Case 1: Form has a preferred shipping rate - try to find matching line
    if (preferredOption) {
      const matchingLine = this.selectedDeliveryDate.shippingLines?.find(
        (line) => line.shippingMethod === preferredOption,
      );

      if (matchingLine) {
        // Found matching line - use it
        this.selectedShippingLine = matchingLine;
        this.formGroup.controls.preferredShippingRateOption.setValue(
          matchingLine.shippingMethod,
          { emitEvent: false },
        );
      } else if (
        this.selectedDeliveryDate.shippingLines &&
        this.selectedDeliveryDate.shippingLines.length > 0
      ) {
        // Preferred option not found - fall back to first line (matches old QMC line 1021)
        this.selectedShippingLine = this.selectedDeliveryDate.shippingLines[0];
        this.formGroup.controls.preferredShippingRateOption.setValue(
          this.selectedShippingLine.shippingMethod,
          { emitEvent: false },
        );
      }
    } else if (
      this.selectedDeliveryDate.shippingLines &&
      this.selectedDeliveryDate.shippingLines.length > 0
    ) {
      // Case 2: No preferred option - default to first line (matches old QMC lines 1023-1026)
      this.selectedShippingLine = this.selectedDeliveryDate.shippingLines[0];
      this.formGroup.controls.preferredShippingRateOption.setValue(
        this.selectedShippingLine.shippingMethod,
        { emitEvent: false },
      );
    }
  }

  /**
   * Subscribe to totals calculation completion
   * Returns an observable that emits true when totals finish calculating
   * Matches old QMC pattern (lines 607-610)
   *
   * Usage in parent component:
   * formComponent.subscribeTotalsComplete().subscribe(result => {
   *   if (result) {
   *     // Totals are complete, safe to save
   *   }
   * });
   */
  subscribeTotalsComplete() {
    return this.totalsResult.asObservable();
  }

  /**
   * Reset totals observer after save completes
   * Matches old QMC line 641
   * This must be called after save completes to prepare for next save
   */
  resetTotalsObserver(): void {
    this.totalsResult = new Subject<boolean>();
  }

  /**
   * Check if form is valid for submission
   * Minimal validation - let API handle the rest (matches old QMC behavior)
   * @returns True if basic required fields are filled
   */
  isValid(): boolean {
    const formValues = this.formGroup.value;
    return !!(
      formValues.customerId &&
      formValues.scheduledOrderItems &&
      formValues.scheduledOrderItems.length > 0
    );
  }

  /**
   * Check if a specific step can be navigated to
   * @param stepIndex The step index to check
   * @returns True if the step can be navigated to
   */
  canNavigateToStep(stepIndex: number): boolean {
    const formValues = this.formGroup.value;

    // Step 0 (Customer) - Always accessible
    if (stepIndex === 0) return true;

    // EDIT MODE: Allow free navigation to all pages
    // User needs to be able to navigate to any page to fix issues,
    // even if there are no products (e.g., failed order, products removed)
    if (this.mode === "edit") {
      return true;
    }

    // CREATE MODE: Enforce progressive disclosure
    // Step 1 (Products) - Requires customer to be selected
    if (stepIndex === 1) {
      return !!formValues.customerId;
    }

    // Step 2+ - Require both customer and at least one product
    return !!(
      formValues.customerId &&
      formValues.scheduledOrderItems &&
      formValues.scheduledOrderItems.length > 0
    );
  }

  /**
   * Check if a specific step is actually complete (has all required data)
   * Used for showing checkmark/completion badge
   * @param stepIndex The step index to check (0-based, adjusted for showValidation offset)
   * @returns True if the step has all required data
   */
  isStepComplete(stepIndex: number): boolean {
    const formValues = this.formGroup.value;

    // Adjust for showValidation offset
    const actualStep = this.showValidation ? stepIndex - 1 : stepIndex;

    switch (actualStep) {
      case -1: // Summary step (only in edit mode)
        return true; // Always complete - it's just an overview

      case 0: // Customer step
        return !!formValues.customerId;

      case 1: // Products step
        return !!(
          formValues.scheduledOrderItems &&
          formValues.scheduledOrderItems.length > 0
        );

      case 2: // Schedule step
        return !!(
          formValues.frequencyType &&
          formValues.frequency &&
          formValues.nextOccurrenceUtc
        );

      case 3: // Payment step
        // Valid if either: existing payment method selected OR new payment method form is valid
        return !!formValues.paymentMethodId || this.isNewPaymentMethodValid;

      case 4: // Shipping step
        return !!(
          formValues.shippingFirstName &&
          formValues.shippingLastName &&
          formValues.shippingStreet1 &&
          formValues.shippingCity &&
          formValues.shippingPostcode &&
          formValues.shippingCountry
        );

      case 5: // Coupons step (optional)
        return true; // Always complete (optional step)

      case 6: // Options step (optional)
        return true; // Always complete (optional step)

      case 7: // Validation Checks step (only in edit mode)
        // Validation is complete only when there are no validation errors
        return (
          this.scheduledOrder?.ValidationResult?.Succeeded === true ||
          (this.scheduledOrder?.ValidationResult?.ErrorItems?.length ?? 0) === 0
        );

      default:
        return false;
    }
  }

  /**
   * Check if a step should show error state (visited but incomplete)
   * @param stepIndex The step index to check
   * @returns True if step should show error/warning state
   */
  isStepInvalid(stepIndex: number): boolean {
    // Only show error if user has navigated past this step but it's incomplete
    return this.currentStep() > stepIndex && !this.isStepComplete(stepIndex);
  }

  /**
   * Check if form can be submitted
   * Based on actual form values, not the original model
   * Requires: customer, items, schedule, payment method, and shipping address
   * @returns True if form has all required data for submission
   */
  get canSubmit(): boolean {
    const formValues = this.formGroup.value;

    // Customer is required
    if (!formValues.customerId) {
      return false;
    }

    // At least one product is required
    if (
      !formValues.scheduledOrderItems ||
      formValues.scheduledOrderItems.length === 0
    ) {
      return false;
    }

    // Schedule (next occurrence date) is required
    if (!formValues.nextOccurrenceUtc) {
      return false;
    }

    // Payment method is required - either existing OR valid new payment method
    if (!formValues.paymentMethodId && !this.isNewPaymentMethodValid) {
      return false;
    }

    // Shipping address is required (country and city at minimum for shipping rate calculation)
    if (!formValues.shippingCountry || !formValues.shippingCity) {
      return false;
    }

    // Cannot submit while saving
    if (this.isSaving) {
      return false;
    }

    return true;
  }

  /**
   * Get validation errors for display
   * Returns all validation errors that prevent form submission
   * @returns Array of validation error messages
   */
  getValidationErrors(): string[] {
    const errors: string[] = [];
    const formValues = this.formGroup.value;

    if (!formValues.customerId) {
      errors.push("Customer is required");
    }
    if (
      !formValues.scheduledOrderItems ||
      formValues.scheduledOrderItems.length === 0
    ) {
      errors.push("At least one product is required");
    }
    if (!formValues.nextOccurrenceUtc) {
      errors.push("Next occurrence date is required");
    }
    if (!formValues.paymentMethodId && !this.isNewPaymentMethodValid) {
      errors.push("Payment method is required");
    }
    if (!formValues.shippingCountry || !formValues.shippingCity) {
      errors.push("Shipping address (country and city) is required");
    }

    return errors;
  }

  /**
   * Handle new payment method validity change from PaymentSelectorComponent
   * Updates the local tracking state used for step validation
   * @param isValid True if new payment method form has all required fields
   */
  onNewPaymentMethodValidChange(isValid: boolean): void {
    this.isNewPaymentMethodValid = isValid;
  }

  /**
   * Reload payment methods and select the specified one.
   * Called after a new payment method is created during save.
   */
  refreshPaymentMethodSelection(paymentMethodId: number): void {
    this.paymentSelector?.reloadAndSelect(paymentMethodId);
    this.isNewPaymentMethodValid = false;
  }

  /**
   * Get customer's next occurrence in their timezone
   * Matches old QMC lines 549-568
   */
  getCustomerNextOccurrence(): Date | undefined {
    const formValues = this.formGroup.value;

    if (
      !formValues.nextOccurrenceUtc ||
      !formValues.nextOccurrenceTime ||
      !this.site
    ) {
      return undefined;
    }

    const date = new Date(formValues.nextOccurrenceUtc);
    return TimezoneHelper.getCustomerNextOccurrence(
      date,
      formValues.nextOccurrenceTime,
      this.site.UtcOffset || 0,
    );
  }

  /**
   * Get processing time with offset applied
   * Matches old QMC lines 570-590
   */
  getProcessingTime(): Date | undefined {
    const formValues = this.formGroup.value;

    if (
      !formValues.nextOccurrenceUtc ||
      !formValues.nextOccurrenceTime ||
      !formValues.nextOccurrenceOffset ||
      !this.site
    ) {
      return undefined;
    }

    const date = new Date(formValues.nextOccurrenceUtc);
    return TimezoneHelper.getProcessingTime(
      date,
      formValues.nextOccurrenceTime,
      this.site.UtcOffset || 0,
      formValues.nextOccurrenceOffset,
    );
  }

  /**
   * Get formatted UTC offset for display
   * Matches old QMC lines 592-603
   */
  getFormattedUtcOffset(utcOffset: number | null): string {
    return TimezoneHelper.getFormattedUtcOffset(utcOffset);
  }

  /**
   * Toggle advanced options visibility
   * Matches old QMC lines 1538-1548
   */
  toggleAdvancedOptions(): void {
    // If trying to enable and not allowed, show upgrade dialog
    if (!this.showAdvancedOptions() && !this.advancedOptionsAllowed) {
      this.showUpgradeDialog = true;
      return;
    }

    // Otherwise toggle normally
    this.showAdvancedOptions.set(!this.showAdvancedOptions());
  }

  /**
   * Get shipping rates title text with count
   * Matches old QMC lines 963-974
   * @returns Title string showing number of available shipping rates
   */
  getShippingRatesTitleText(): string {
    const order = this.buildOrderFromForm();

    if (!order || !order.ShippingRateOptions) {
      return "Shipping Rates";
    }

    const ratesCount = order.ShippingRateOptions.length;

    if (ratesCount === 0) {
      return "No Shipping Rates Available";
    }

    return `${ratesCount} Shipping ${ratesCount === 1 ? "Rate" : "Rates"} Available`;
  }

  /**
   * Get scheduled order object for shipping-rate-selector component
   * CRITICAL: For edit mode, returns the ACTUAL loaded scheduledOrder object (matches old QMC line 999)
   * This ensures ALL fields from the API are included in the shipping rates request
   * For create mode, builds from form since no order exists yet
   * @returns ScheduledOrder object - actual loaded order (edit) or built from form (create)
   */
  getScheduledOrderForShippingRates(): ScheduledOrder {
    // CRITICAL: For edit mode, return the actual loaded order object (matches old QMC behavior)
    // The old QMC passes this.scheduledOrder directly to the shipping rates API
    // This ensures complete data including all Product metadata, Customer details, etc.
    if (this.mode === "edit" && this.scheduledOrder) {
      return this.scheduledOrder;
    }

    // For create mode, build from form since no loaded order exists
    return this.buildOrderFromForm();
  }

  /**
   * Handle shipping rate options loaded from shipping-rate-selector component
   * Stores the loaded options for use in save payload
   * @param options Loaded shipping rate options from API
   */
  onShippingRateOptionsLoaded(options: any[]): void {
    // Store shipping rate options for API calls (matches old QMC lines 1001-1004)
    this.shippingRateOptions = options || [];

    // Set FreeShipping from ShippingRateOptions (matches old QMC line 1003)
    const freeShipping = options?.find((s) => s.IsDefault);
    if (freeShipping) {
      this.freeShipping = freeShipping;
    }

    // NOTE: Don't call calculateTotals() here - the shipping-rate-selector component
    // already calls it before fetching rates. Calling it again here causes double API calls.
  }

  /**
   * Handle auto shipping rate toggle event
   * Recalculates totals when user toggles the auto rate checkbox
   * Matches old QMC behavior where toggling auto rate triggers recalculation
   * @param isEnabled Whether auto rate is now enabled
   */
  onAutoRateToggled(_isEnabled: boolean): void {
    // Recalculate totals with the new auto rate setting
    this.calculateTotals();
  }

  /**
   * Check if an item should be included in calculations (not disabled)
   * Uses the same logic as item-manager's isItemEnabled() method
   * This ensures consistency between UI display and API calculations
   * @param item Scheduled order item from form
   * @returns True if item should be included in calculations
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isItemEnabled(item: any): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const product = item.product;
    if (!product) return false;
    return this.productIsActive(product) && !this.disabledForBackorders(item);
  }

  /**
   * Check if there are any disabled items in the order
   * Used to conditionally show "Enabled Order Items" vs "Order Items" labels
   * @returns True if at least one item is disabled
   */
  hasDisabledItems(): boolean {
    const items = this.formGroup.controls.scheduledOrderItems.controls;
    return items.some((itemControl) => {
      const item = itemControl.value;
      return !this.isItemEnabled(item);
    });
  }

  /**
   * Check if product is active (can be processed)
   * Matches item-manager logic and old QMC lines 398-408
   * @param product Product object
   * @returns True if product is active
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private productIsActive(product: any): boolean {
    return (
      this.productIsInStock(product) &&
      this.productIsProcessing(product) &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Active &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Valid
    );
  }

  /**
   * Check if product is in stock
   * Matches item-manager logic and old QMC lines 402-404
   * @param product Product object
   * @returns True if product is in stock
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private productIsInStock(product: any): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.StockLevel === "Undefined" || product.StockLevel === "InStock"
    );
  }

  /**
   * Check if product is enabled for processing scheduled orders
   * Matches item-manager logic and old QMC lines 406-408
   * @param product Product object
   * @returns True if product can process scheduled orders
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private productIsProcessing(product: any): boolean {
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Availability &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      product.Availability.indexOf("ProcessScheduledOrder") > -1
    );
  }

  /**
   * Check if item is disabled due to backorder restrictions
   * Matches item-manager logic and old QMC lines 1579-1582
   * @param item Scheduled order item
   * @returns True if item is disabled for backorders
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private disabledForBackorders(item: any): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const product = item.product;
    if (!product) return false;

    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.BackordersAllowed != null &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      !product.BackordersAllowed &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Stock != null &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      product.Stock < item.quantity
    );
  }
}
